import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { selectChannel } from '@/modules/Channels';
import { useAppDispatch, useAppState } from '@/store';
import { getRedirects } from '../feature';
import { GetRedirectsDTO } from '../dtos/GetRedirects.dto';

const useSearchRedirects = () => {
  const dispatch = useAppDispatch();
  const channel = useAppState(selectChannel);

  const [searchValue, setSearchValue] = useState('');

  const handleDebouncedSearchRedirects = useMemo(
    () =>
      debounce(async (query: string) => {
        const dto = new GetRedirectsDTO({ page: '1', query, channelId: channel?.id ?? 0 });
        dispatch(getRedirects(dto));
      }, 500),
    [dispatch, channel?.id],
  );

  const handleSearchRedirects = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setSearchValue(value);
      handleDebouncedSearchRedirects(value);
    },
    [handleDebouncedSearchRedirects],
  );

  const handleResetSearchValue = useCallback(() => {
    setSearchValue('');
  }, []);

  return useMemo(
    () => ({
      handleSearchRedirects,
      searchValue,
      handleResetSearchValue,
    }),
    [handleSearchRedirects, searchValue, handleResetSearchValue],
  );
};

export default useSearchRedirects;
